import {gql} from '@apollo/client'
export const queryCompanyList=gql`
query Query($page: Int!, $count: Int!, $name: String) {
    companyList(page: $page, count: $count, name: $name) {
      data {
        _id
        company
        developerEmail
        nationality
        region
        createTime
      }
      total
    }
  }
  
`
